interface LogoProps {
  className?: string
}

export default function Logo({ className = "w-10 h-10" }: LogoProps) {
  return (
    <img
      src="/autocaravana_logo.png"
      alt="Autocaravana Logo"
      className={`object-contain ${className}`}
      draggable={false}
    />
  )
}
